import React from "react";
import { useNavigate } from "react-router-dom";
import { MOODS } from "../../data/exerciseCatalog";

// Props:
//   onClose      — exit without selecting
//   onMoodSelect — (mood) called when user picks a mood or skips

const MoodGrid = ({ onClose, onMoodSelect }) => {
  const navigate = useNavigate();

  const skipHandler = () => {
    const randomMood = MOODS[Math.floor(Math.random() * MOODS.length)];
    onMoodSelect(randomMood);
  };

  const browseCapsuleHandler = () => {
    onClose();
    navigate("/micro-exercises");
  };

  return (
    <div className="tw-relative tw-w-full tw-h-full tw-bg-gradient-to-br tw-from-[#20162f] tw-via-[#4f2488] tw-to-[#101827] tw-py-10 tw-flex tw-flex-col tw-justify-center tw-overflow-auto tw-rounded-[inherit]">
      <button
        onClick={onClose}
        className="tw-absolute tw-top-4 tw-left-4 tw-text-2xl tw-text-white hover:tw-text-gray-200"
      >
        ✕
      </button>
      <span
        className="tw-absolute tw-top-4 tw-right-4 tw-font-semibold tw-text-base tw-text-white tw-cursor-pointer hover:tw-text-gray-200"
        onClick={skipHandler}
      >
        Skip
      </span>

      <h1 className="tw-mb-1 tw-text-2xl md:tw-text-4xl tw-font-bold tw-text-white tw-text-center">
        How are you feeling today?
      </h1>
      <p className="tw-text-center tw-text-base tw-font-normal tw-text-white/80">
        Pick your vibe and we'll find the perfect capsule for you
      </p>

      <div className="tw-flex tw-justify-center">
          <div className="tw-grid tw-grid-cols-3 tw-gap-2 md:tw-gap-5 tw-mt-6 md:tw-mt-10 tw-justify-items-center tw-w-full md:tw-w-[640px] tw-px-3 md:tw-px-0">
            {MOODS.map((mood) => (
              <button
                key={mood.id}
                onClick={() => onMoodSelect(mood)}
                // className="tw-p-2 md:tw-p-6 tw-rounded-2xl md:tw-rounded-3xl tw-bg-white/10 tw-backdrop-blur-sm tw-border-[0.5px] tw-border-solid tw-border-white hover:tw-bg-white/20 hover:tw-scale-105 tw-transform tw-transition-transform tw-w-full tw-h-24 md:tw-w-[160px] md:tw-h-32 tw-flex tw-flex-col tw-items-center tw-justify-center"
                className="tw-p-2 md:tw-p-6 tw-rounded-2xl md:tw-rounded-3xl tw-bg-white/10 tw-backdrop-blur-md tw-border tw-border-white/25 hover:tw-bg-white/18 hover:tw-border-white/45 hover:tw-scale-[1.03] tw-transform tw-transition-all tw-duration-200 tw-w-full tw-h-24 md:tw-w-[160px] md:tw-h-32 tw-flex tw-flex-col tw-items-center tw-justify-center"
              >
                <div className="tw-mb-2">
                  {mood.svg_icon ? (
                    <img
                      src={mood.svg_icon}
                      alt={mood.name}
                      className="tw-w-16 tw-h-12 md:tw-w-[120px] md:tw-h-16 tw-mx-auto"
                    />
                  ) : (
                    <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-white/20 tw-flex tw-items-center tw-justify-center tw-text-xl tw-mx-auto">
                      {mood.name?.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="tw-text-white tw-font-medium tw-text-[12px] md:tw-text-[15px] tw-capitalize">
                  {mood.name}
                </div>
              </button>
            ))}
          </div>
        </div>

      <p className="tw-pt-6 tw-text-center tw-text-[14px] tw-text-white/70">
        Not sure about your mood? Explore our Capsule Deck below
      </p>
      <button
        className="tw-block tw-mx-auto tw-px-6 tw-py-2 tw-text-base tw-rounded-3xl tw-bg-white/10 tw-backdrop-blur-sm tw-border-[0.5px] tw-border-solid tw-border-white tw-mt-3 tw-text-white hover:tw-bg-white/20 tw-transition-colors"
        onClick={browseCapsuleHandler}
      >
        Browse Capsules
      </button>
    </div>
  );
};

export default MoodGrid;
